export default "__VITE_ASSET__CsXZRb1V__"